import { isTokenExpired, isTokenAlmostExpired } from "./jwtHelper";
import { post, setHeaders } from "./axiosInstance";

// =========================================================================================================
// ROLES DEFINITION ========================================================================================
// =========================================================================================================

export const SUPER_USER = "superUser";
export const MARKET_USER = "marketUser";
export const DELIVERY_USER = "deliveryUser";
export const PLANT_USER = "plantUser";
export const SERVICE_PROVIDER = "serviceProvider";

// =========================================================================================================

export function login(username, password, history, callback) {
  post("/api-token-auth/", { username: username, password: password })
    .then((r) => {
      setToken(r.data.token);
      setUserData(r.data.user);

      // Check if user is a service provider
      if (r.data.is_service_provider) {
        setServiceProviderData(r.data.service_provider);
        history.push("/provider-portal");
      } else {
        clearServiceProviderData();
        history.push("/orders");
      }
    })
    .catch((err) => {
      if (callback) {
        if (!err.response) {
          callback("Something is wrong!");
        }

        if (err.response && err.response.status) {
          switch (err.response.status) {
            case 400:
              callback("Can't login with provided credentials.");
              break;
            case 500:
              callback("There is a problem with the server.");
              break;
            default:
              callback("Something is wrong!");
          }
        }
      }
    });
}

export function getToken() {
  // Retrieves the user token from localStorage
  return localStorage.getItem("id_token");
}

export function setToken(idToken) {
  // Saves user token to localStorage
  localStorage.setItem("id_token", idToken);
  // Add authentication header to axios
  setHeaders(idToken);
}

export function setUserData(data) {
  // Saves user data to localStorage
  localStorage.setItem("user", JSON.stringify(data));
}

export function getUserData() {
  return JSON.parse(localStorage.getItem("user"));
}

export function isLoggedIn() {
  // Checks if there is a saved token and it's still valid
  var token = getToken();
  if (!token || isTokenExpired(token)) {
    logout();
    return false;
  } else if (isTokenAlmostExpired(token)) {
    post("/api-token-refresh/", { token: token })
      .then((r) => {
        setToken(r.data.token);
        return true;
      })
      .catch((err) => {
        console.log("error", err);
      });
  }
  return !!token && !isTokenExpired(token);
}

export function isPlantUser() {
  const user = getUserData();
  return user && user.is_plant_user;
}

export function isMarketUser() {
  const user = getUserData();
  return user && user.is_market_user;
}

export function isDeliveryUser() {
  const user = getUserData();
  return user && user.is_delivery_user;
}

export function isSuperUser() {
  const user = getUserData();
  return user && user.is_superuser;
}

export function isStaffUser() {
  const user = getUserData();
  return user && (user.is_staff || user.is_superuser);
}

export function check_allowed_role(roles) {
  if (roles.includes(MARKET_USER) && isMarketUser()) {
    return true;
  }
  if (roles.includes(DELIVERY_USER) && isDeliveryUser()) {
    return true;
  }
  if (roles.includes(PLANT_USER) && isPlantUser()) {
    return true;
  }
  if (roles.includes(SUPER_USER) && isSuperUser()) {
    return true;
  }
  return false;
}

export function logout() {
  // Clear user token and profile data from localStorage
  localStorage.removeItem("id_token");
  localStorage.removeItem("user");
  localStorage.removeItem("service_provider");
}

// =========================================================================================================
// SERVICE PROVIDER FUNCTIONS ==============================================================================
// =========================================================================================================

export function setServiceProviderData(data) {
  // Saves service provider data to localStorage
  localStorage.setItem("service_provider", JSON.stringify(data));
}

export function getServiceProviderData() {
  const data = localStorage.getItem("service_provider");
  return data ? JSON.parse(data) : null;
}

export function clearServiceProviderData() {
  localStorage.removeItem("service_provider");
}

export function isServiceProvider() {
  return getServiceProviderData() !== null;
}
